export default "__VITE_ASSET__ByhlqWo6__"